import React from "react";
import { Link, useLocation } from 'react-router-dom';
import my_shopping from '../../assets/icon/my_shopping.svg';
import my_inquiry from '../../assets/icon/my_inquiry.svg';
import my_account from '../../assets/icon/my_account.svg';
import { useLanguage } from "../../hooks/useLanguage";

function MyLeftNavi({myInfo}) {
  const { t } = useLanguage();
  const location = useLocation();


  const iconMap = {
    '나의 쇼핑정보' : my_shopping,
    '나의 문의정보' : my_inquiry,
    '나의 계정설정' : my_account
  };

  const naviList = {
    [t('my_shopping_info')]: [
      {
        name: t('store_order_management2'),
        url: '/myPage/orderManagement?type=visit',
        value: 'visit'
      },
      {
        name: t('delivery_management'),
        url: '/myPage/orderManagement?type=parcel',
        value: 'parcel'
      },
      { name: t('quotation_management'), 
        url: '/myPage/orderManagement?type=estimate',
        value: 'estimate'
      },
      {
        name: t('sale_product_order_management'),
        url: '/myPage/orderManagement?type=sale',
        value: 'sale'
      },
      { 
        name: t('interest_product'), 
        url: '/myPage/wishList' 
      },
      { 
        name: t('deposit_info_8'), 
        url: '/myPage/deposit' 
      },
      {
        name: t('point'),
        url: '/myPage/point'
      },
      { 
        name: t('coupon'), 
        url: '/myPage/coupon' 
      },
    ],

    [t('my_inquiry_info2')]: [
      { 
        name: t('production_support'), 
        url: '/myPage/support' 
      },
      { 
        name: t('inquiry'), 
        url: '/myPage/inquiry' 
      },
      { 
        name: t('customization'), 
        url: '/myPage/customizing' 
      },
      { 
        name: t('lowest_price_guarantee'), 
        url: '/myPage/priceGuarantee' 
      },
    ],

    [t('my_account_settings')]: [
      {
        name: t('delivery_address_book_management'),
        url: '/myPage/delivery'
      },
      {
        name: t('member_info_2'), 
        url: '/myPage/profile/edit' 
      },
    ],
  };

  // const isActive = (url) => {
  //   if (!url) return false; // url이 비어있는 경우

  //   // 현재 경로 (쿼리 포함)
  //   const current = location.pathname + location.search ;
  //   return current === url; 
  // };

  const isActive = (url) => {
    if (!url) return false;

    // 현재 경로와 쿼리 파라미터 파싱
    const currentPathname = location.pathname;
    const currentSearch = new URLSearchParams(location.search);
    const currentType = currentSearch.get('type');

    // 메뉴 URL 파싱
    const menuUrl = new URL(url, window.location.origin);
    const menuPathname = menuUrl.pathname;
    const menuSearch = new URLSearchParams(menuUrl.search);
    const menuType = menuSearch.get('type');

    // 기본 경로 매칭
    if (currentPathname === menuPathname && currentType === menuType) return true;
    
    // 상세 페이지 경로 매칭을 위한 부모 경로 매핑
    const parentPaths = {
      '/myPage/orderManagement': {
        paths: [
          '/myPage/order',              // 주문 상세
          // '/myPage/orderExtension',     // 연장 신청
          '/myPage/orderReturnDetail',  // 반품 상세
          '/myPage/orderExchangeDetail', // 교환 상세
          '/myPage/orderReturnForm',    // 반품 신청
          '/myPage/orderExchangeForm'   // 교환 신청
        ],
        checkType: true // type 파라미터를 체크해야 하는 경로
      },
      '/myPage/deposit': {
        paths: [
          '/myPage/deposit/charge',  // 예치금 충전
          '/myPage/deposit/refund'   // 예치금 환불
        ],
        checkType: false
      },
      '/myPage/support': {
        paths: ['/myPage/support/'],
        checkType: false
      },
      '/myPage/inquiry': {
        paths: ['/myPage/inquiry/'],
        checkType: false
      },
      '/myPage/customizing': {
        paths: ['/myPage/customizing/'],
        checkType: false
      },
      '/myPage/priceGuarantee': {
        paths: ['/myPage/priceGuarantee/'],
        checkType: false
      },
      '/myPage/delivery': {
        paths: ['/myPage/delivery/register'],
        checkType: false
      }
    };

    // 현재 경로가 특정 부모 메뉴에 속하는지 확인
    for (const [parentUrl, config] of Object.entries(parentPaths)) {
      if (config.paths.some(path => currentPathname.startsWith(path))) {
        // 부모 URL과 현재 메뉴 URL이 일치하는지 확인
        if (parentUrl === menuPathname) {
          // type 체크가 필요한 경우
          if (config.checkType) {
            return currentType === menuType;
          }
          return true;
        }
      }
    }

    return false;
  };


  return (
    <nav className="my_navi">
      <div className="user_info tablet_hide">
        <p className="grade">{myInfo?.mem_kind_txt}</p>
        <p className="name">{myInfo?.user_name}</p>
      </div>

      {Object.entries(naviList).map(([category, items]) => (
        <dl key={category} className="navi_list">
          <dt className="title flex-center-2">
            {iconMap[category] && (
              <img src={iconMap[category]} alt="iconMap" className="icon_map" loading="lazy"/>
            )}
            {category}
          </dt>
          <div>
            {items.map((item) => (
              <Link
                to={item.url}
                key={item.name}
                className={`${isActive(item.url) ? 'active' : ''} category`}
                state={item.value ? { type: item.value } : undefined}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </dl>
      ))}
    </nav>
  );
}

export default MyLeftNavi;